import { METHOD } from './method'

export const API_PRODUCT_IMPORT = {
    DOWNLOAD_TEMPLATE: {
        api: '/v1/dashboard-admin/product/import/download-template',
        method: METHOD.GET,
    },
    IMPORT: {
        api: '/v1/dashboard-admin/product/import',
        method: METHOD.POST,
    },
}
